/** Saved source references and question-neutral supporting-record presentation; never a latest-record lookup. */
import * as z from 'zod';
import { insightEntitySchema } from './insight-entity.js';
export const insightOrderRecordSchema = z.strictObject({
    orderId: z.string().min(1),
    name: z.string().nullable(),
    createdAt: z.iso.datetime({ offset: true }).nullable(),
});
/** A complete, distinct, deterministic membership list. Its question owner reconciles the population/count. */
export const insightOrderRecordsSchema = z.array(insightOrderRecordSchema).superRefine((records, ctx) => {
    if (records.some((record, index) => index > 0 && records[index - 1].orderId >= record.orderId))
        ctx.addIssue({ code: 'custom', message: 'INSIGHT_PRESENTATION_INVALID: duplicate or unordered supporting orders' });
});
export const insightSupportingRecordsSchema = z.strictObject({
    title: z.string().min(1),
    description: z.string().min(1),
    records: z.array(z.strictObject({ entity: insightEntitySchema, description: z.string().min(1) })).min(1),
});
//# sourceMappingURL=insight-supporting-records.js.map